import { atom, } from "recoil";

export default class AtomStore {
    static setAtom(key, defaultValue) {
        window.atoms = window.atoms || {}
        if (key && defaultValue && !window.atoms[key]) {
            window.atoms[key] = atom({
                key,
                default: defaultValue,
            })
        }
    }

    static getAtom() {
        return window.atoms;
    }
}

